import React from 'react';
import CreateBtn from './components/CreateBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import ContentTypeSelect from './components/ContentTypeSelect';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import WithURLFilters from './components/WithURLFilters';
import style from './TeasersControlPanel.module.scss';

const TeasersControlPanel = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<div className={style.selectWrapper}>
					<CustomerSelect />
					<RestaurantSelect />
					<ContentTypeSelect />
					<CreateBtn />
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default TeasersControlPanel;
